export default __webpack_public_path__ + "static/media/logo.f5cf1c44.jpg";